import React, { useState, useEffect } from 'react';
import '../App.css'

import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500 animate-spin"></div>
    </div>
  );
}

var url = process.env.REACT_APP_URL || "http://localhost:8080/";
function Scrape() {

  const [filteredQrCodes, setFilteredQrCodes] = useState([]);
  const [searchCampaign, setSearchCampaign] = useState('');  // State to keep track of the search input

  const [loading, setLoading] = useState(false);
  const [qrCodes, setQrCodes] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editWebsite, setEditWebsite] = useState("");
  const [website, setWebsite] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoFileChanged, setVideoFileChanged] = useState(null);

  const [qrCode, setQrCode] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const { homeDataState, dispatch } = React.useContext(HomeDataContext);

  useEffect(() => {
    async function fetchQrCodes() {
      const response = await fetch(`${process.env.REACT_APP_URL || "http://localhost:8080/"}api/pnl/tour/d-id/getallscrapes`);
      const data = await response.json();
      console.log(data)
      setQrCodes(data);
      setFilteredQrCodes(data);
    }
    fetchQrCodes();
  }, []);

  useEffect(() => {
     const filtered = qrCodes.filter(qrCode =>
       qrCode.hotel ? qrCode.hotel.toLowerCase().includes(searchCampaign.toLowerCase()) : false
     );
    setFilteredQrCodes(filtered);
  }, [searchCampaign, qrCodes]);
  const handleSearchChange = (event) => {
    setSearchCampaign(event.target.value);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setVideoFileChanged(file);  // Consider renaming this function to something more appropriate like setFile
    } else {
      alert('Please select a file.');
      setVideoFileChanged(null);  // Consider renaming this to clear the context since it's not just for videos anymore
    }
  };


  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      setVideoFileChanged(file);
    } else {
      alert('Please select a video file.');
      setVideoFileChanged(null);
    }
  };

  const handleEdit = (qrCode) => {
    console.log(qrCode)
    setEditId(qrCode._id);
    setEditName(qrCode.hotel);
    setEditEmail(qrCode.email);
    setEditWebsite(qrCode.website)
  };

  const createDownloadLink = (text, filename) => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'download.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);  // Clean up the DOM
    URL.revokeObjectURL(url);  // Free up memory used by the blob
  };
  const handleSave = async (id) => {

    setLoading(true);
    try {
      // Prepare FormData
      const formData = new FormData();
      if (videoFileChanged) {
        formData.append('file', videoFileChanged);
      }
      // Append the file
      formData.append('id', editId);
      formData.append('name', editName); 
      formData.append('email', editEmail);
      formData.append('website', editWebsite);

      console.log(formData)
      const response = await fetch(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/update_scraped`, {  
       // const response = await fetch(`http://localhost:5000/update_scraped`, { 
        method: 'POST',
        body: formData

      });

      if (response.ok) {
        const data = await response.json(); // Or .text() if the response is not in JSON format
        alert("Success");
        window.location.reload()
      } else {
        alert('Upload failed');
      }
    } catch (error) {
      console.error('Error while uploading:', error);
      alert("Error while updating")
    } finally {
      setLoading(false);
    }


  };
  const renderEditableFields = (qrCode) => {
    return (
      <div className="flex flex-wrap items-center w-full gap-4">
        {editId === qrCode._id ? (
          <>
            <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} className="flex-auto min-w-[250px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Hotel name" />
            <input type="text" value={editEmail} onChange={(e) => setEditEmail(e.target.value)} className="flex-auto min-w-[250px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Hotel email" />
            <input type="text" value={editWebsite} onChange={(e) => setEditWebsite(e.target.value)} className="flex-auto min-w-[250px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Hotel website" />
            <input type="file" accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain" onChange={handleFileChange} className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100" />
            <button onClick={() => handleSave(qrCode._id)} className="flex-none bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300">Save</button>
          </>
        ) : (
          <>
            <div className="flex flex-1 gap-2">
              <p className="flex-auto min-w-[300px]" style={{ textAlign: 'left' }}>{qrCode.hotel}</p>

              <p className="flex-auto min-w-[400px] text-left" style={{ textAlign: 'left' }}>{qrCode.email}</p>
              <p className="flex-auto min-w-[400px] text-left" style={{ textAlign: 'left' }}>{qrCode.website}</p>
              <button onClick={() => createDownloadLink(qrCode.documentstext, "text.txt")} className="flex-none bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Download uploaded data</button>
              {(qrCode.faq!="") && <button onClick={() => createDownloadLink(qrCode.faq, "questions.txt")} className="flex-none bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Download FAQ</button>}
            </div>
            <button onClick={() => handleEdit(qrCode)} className="flex-none bg-gray-300 hover:bg-gray-500 text-black font-bold py-2 px-4 rounded transition duration-300">Edit</button>
          </>
        )}
      </div>
    );
  };

  const handleUpload = async () => {
    setLoading(true);


    try {
      // Prepare FormData
      const formData = new FormData();
      formData.append('file', videoFileChanged);  // Append the file
      formData.append('name', name);  // Append other data if necessary
      formData.append('email', email);
      formData.append('website', website);

      console.log(formData)

      const response = await fetch('https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/process_upload', {
       // const response = await fetch(`http://localhost:5000/process_upload`, { 
        method: 'POST',
        body: formData  // Send formData
        // Note: Do not set 'Content-Type' header when sending FormData
        // It will be set automatically by the browser, including the boundary parameter
      });

      if (response.ok) {
        const data = await response.json(); // Or .text() if the response is not in JSON format
        alert("Success. FAQ are curently being created. Refresh page after approx 15m mins to see them.");
        window.location.reload()
      } else {
        alert('Upload failed because file format is not good.');
      }
    } catch (error) {
      console.error('Error while uploading:', error);
      alert('Error while uploading');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      {loading && <LoadingOverlay />}
      <div className="space-y-4 w-full max-w-lg mx-auto text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Scrape hotel data</h1>
        <div>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Hotel name" className="w-full px-3 py-2 mb-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Hotel email" className="w-full px-3 py-2 border mb-4 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
          <input type="text" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="Hotel website " className="w-full px-3 mb-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
          <input type="file" accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain" onChange={handleFileChange} className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100" />

          <button onClick={handleUpload} className="px-4 mt-8 py-2 bg-blue-500 text-white font-bold rounded hover:bg-blue-700 transition duration-300">Upload</button>

        </div>
      </div>

      <div className="flex justify-between mt-16   items-center w-full px-4 py-2">
        <div className="flex-1">
          {/* Left space if needed */}
        </div>
        <input type="text" value={searchCampaign} onChange={handleSearchChange} placeholder="Search by hotel name" className="w-1/3 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
      </div>

      <div className="w-full px-3 py-2 bg-white rounded-lg shadow-md overflow-hidden">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Uploads list</h2>
        {filteredQrCodes.map((qrCode) => (
          <div key={qrCode._id} className="flex flex-col md:flex-row justify-between items-center p-4 border-b last:border-b-0">
            {renderEditableFields(qrCode)}
          </div>
        ))}
      </div>
    </div>



  );
}

export default Scrape;